import React from 'react'
import PaginationDataTable from '../../common/PaginationDataTable'

const TableRecordsList = (props) => {
    return (
        <div className="col-lg-12 mt-3">
            {(props.genericUrlIs !== "" && props.tableColumns.length !== 0) &&
                <PaginationDataTable
                    paginationUrl={props.genericUrlIs}
                    search={true}
                    paginationStatus={true}
                    columns={props.tableColumns} drawCount={props.drawCount}
                    filters={props.sortTableData} 
                    selectedAble={true}
                    setDeleteAbleRowsData={props.setDeleteAbleRowsData}
                    />
            }
            
        </div>
    )
}

export default TableRecordsList